/** Avancement d'un relevé : « 12 / 20 » + barre. */
export function Progress({ done, total, label }: { done: number; total: number; label: string }) {
  const percent = total ? Math.round((done / total) * 100) : 0
  return (
    <div className="grade-progress">
      <div
        className="progress"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <span style={{ width: `${percent}%` }} />
      </div>
      <span className="muted">
        {done} / {total}
      </span>
    </div>
  )
}
